import { Observable } from 'rxjs'
import { WebUserComment } from '../models/web-user-comments'

export abstract class UserCommentsGateway {
    abstract getUserCommentsData(userProfileID: number): Observable<WebUserComment[]>
    abstract addUsercomments(userComments: WebUserComment, userProfileID: number): Observable<WebUserComment>
}
